import React, { FC, useEffect, useState } from 'react';

import { Box, HStack } from '@chakra-ui/react';
import { filter } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { WithResourceIcon } from 'components/DataDisplay';
import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { DeleteActionButton } from 'components/DataEntry';
import { selectUser } from 'containers/App/selectors';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions } from 'containers/Setup/Integrations/slice';

interface ISSOProvidersTable {}

export const SSOProvidersTable: FC<ISSOProvidersTable> = () => {
  const dispatch = useDispatch();
  const { info } = useSelector(selectUser);
  const { sso } = useSelector(selectIntegrations);
  const { providers, deleteProvider } = sso;
  const [data, setData] = useState<Record<string, any>[]>([]);
  const params = useParams<{
    provider: string;
  }>();

  useEffect(() => {
    dispatch(actions.getSSOProviders());
  }, [dispatch]);

  useEffect(() => {
    setData(filter(providers.data, o => o.provider === params.provider));
  }, [providers.data, params.provider]);

  const onDeleteSuccess = () => {
    dispatch(actions.getSSOProviders());
  };

  const onDelete = row => {
    dispatch(
      actions.deleteSSOProvider({
        organization: info.org_id,
        provider: row.provider,
        onSuccess: onDeleteSuccess,
      }),
    );
  };

  const renderAction = ({ row }) => {
    return (
      <HStack justify={'end'}>
        <DeleteActionButton
          onConfirm={() => onDelete(row)}
          isLoading={deleteProvider.loading}
          name={row?.config.client_id}
          type="SSO provider"
        />
      </HStack>
    );
  };

  const columns = [
    {
      header: <Box pl={16}>Identity Provider Name</Box>,
      accessor: 'provider',
      render: ({ value }) => (
        <WithResourceIcon
          resourceType={params.provider!}
          iconFilled={false}
          spacing={10}
          iconSize="regular"
        >
          {value}
        </WithResourceIcon>
      ),
    },
    {
      header: 'Client ID',
      accessor: 'config.client_id',
      align: 'left',
    },
    {
      header: 'Action',
      styles: {
        textAlign: 'right',
        cell: { textAlign: 'right', overflow: 'visible' },
      },

      render: renderAction,
    },
  ];

  return <Table columns={columns} data={data} isLoading={providers.loading} />;
};
